import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

// Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import PresupuestosPage from "./pages/PresupuestosPage";
import NuevoPresupuestoPage from "./pages/NuevoPresupuestoPage";
import DetallePresupuestoPage from "./pages/DetallePresupuestoPage";
import PublicPresupuestoPage from "./pages/PublicPresupuestoPage";
import ClientesPage from "./pages/ClientesPage";
import ConfiguracionPage from "./pages/ConfiguracionPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/registro" element={<RegisterPage />} />
          <Route path="/p/:enlace" element={<PublicPresupuestoPage />} />
          
          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          } />
          <Route path="/presupuestos" element={
            <ProtectedRoute>
              <PresupuestosPage />
            </ProtectedRoute>
          } />
          <Route path="/presupuestos/nuevo" element={
            <ProtectedRoute requiredRoles={['OWNER', 'MANAGER']}>
              <NuevoPresupuestoPage />
            </ProtectedRoute>
          } />
          <Route path="/presupuestos/:id" element={
            <ProtectedRoute>
              <DetallePresupuestoPage />
            </ProtectedRoute>
          } />
          <Route path="/clientes" element={
            <ProtectedRoute>
              <ClientesPage />
            </ProtectedRoute>
          } />
          <Route path="/configuracion" element={
            <ProtectedRoute requiredRoles={['OWNER']}>
              <ConfiguracionPage />
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-right" 
        richColors 
        closeButton
        toastOptions={{
          style: {
            fontFamily: 'Inter, sans-serif',
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
